// import React, { useEffect, useRef, useState } from "react";
// import { useLocation, useNavigate, useParams } from "react-router-dom";
// import Forms from "../../../../Componets/Form";
// import toast from "react-hot-toast";
// import Header from "../../../../Componets/Header";
// import {
//   create_invoice,
//   get_invoice,
//   update_invoice,
// } from "../../../../Controllers/Sales/Invoices";
// import forms from "../../../../Data/Forms/Sales/Invoices/forms";
// import headers from "../../../../Data/Forms/Billings/Billings/headers";
// import Loadercomponent from "../../../../Componets/Loader";
// import Bodycomponent from "../../../../Componets/Formcomponents/body";
// import Titlecomponent from "../../../../Componets/Formcomponents/title";
// import Formdata from "../../../../Componets/Formcomponents/formdata";
// import Headercomponent from "../../../../Componets/Formcomponents/header";
// import BillingPos from "../../../../Data/Forms/Billings/Billings/pos";
// import BillingIcon from "../../../../Assets/Svg/billing";
// import SalesIcon from "../../../../Assets/Svg/sales";
// import { get_auth_branch } from "../../../../Controllers/Settings/Branches";

// const InvoicesForm = () => {
//   let { id } = useParams();
//   let location = useLocation();
//   let navigate = useNavigate();

//   const [loader, setLoader] = useState(false);
//   const [buttonLoader, setButtonLoader] = useState(false);
//   const [values, setValues] = useState(forms);
//   const [header, setHeader] = useState(headers);

//   const submitType = useRef("");

//   const onSubmit = (e) => {
//     e?.preventDefault();
//   };

//   const [customer, setCustomer] = useState();
//   const [options, setOptions] = useState();
//   const [details, setDetails] = useState([]);
//   const [totals, setTotals] = useState({
//     subtotal: "0.000",
//     taxamount: "0.000",
//     discount: 0,
//     delivery: 0,
//     delivery_status: 2,
//     delivery_date: new Date(),
//     payment_status: 2,
//     payment_types: ["Cash"],
//     /* payments: {
//       Cash: "",
//       Cheque: "",
//       "Debit card": "",
//       "Credit card": "",
//       "Bank transfer": "",
//       "Online payment": "",
//     }, */
//     payments: [{
//       id: `temp-cash-initial`,
//       name: "Cash",
//       amount: ""
//     }],
//     paid: 0,
//     remaining: 0,
//     total: "0.000",
//   });

//   const formdata = async (data) => {

//     if (buttonLoader) return;

//     if (data?.status) {
//       if (details?.length > 0) {
//         let details_count = 0;

//         details?.map((v, i) => {
//           if (v?.unit) {
//             details_count++;
//           }
//         });


//         if (details?.length == details_count) {
//           if (totals?.payment_types?.length > 0) {
//             setButtonLoader(true);

//             /*  const paymenttypedata = totals?.payment_types;
//              const paymentdata = { ...totals.payments };
 
//              const allPaymentMethods = ["Cash", "Cheque", "Debit card", "Credit card", "Bank transfer", "Online payment"];
 
//              allPaymentMethods.forEach(method => {
//                if (!paymentdata[method] || paymentdata[method] === "" || paymentdata[method]?.amount === "") {
//                  paymentdata[method] = "";
//                }
//              });
 
//              let totalEnteredPayments = 0;
//              paymenttypedata?.forEach(method => {
//                const amount = paymentdata[method]?.amount;
//                if (amount && amount !== "") {
//                  totalEnteredPayments += parseFloat(amount);
//                }
//              });
 
//              if (totalEnteredPayments === 0 && paymenttypedata.length > 0) {
//                const firstPaymentMethod = paymenttypedata[0];
//                paymentdata[firstPaymentMethod] = { amount: totals?.total };
//              } */

//             const paymenttypedata = totals?.payment_types;

//             const paymentdata = totals?.payments
//               ?.filter(p => p.amount && parseFloat(p.amount) > 0) || [];

//             let totalEnteredPayments = paymentdata.reduce(
//               (sum, p) => sum + parseFloat(p.amount || 0),
//               0
//             );

//             if (totalEnteredPayments === 0 && paymenttypedata.length > 0) {
//               const firstPaymentMethod = paymenttypedata[0];
//               paymentdata.push({
//                 id: `temp-${firstPaymentMethod}-${Date.now()}`,
//                 name: firstPaymentMethod,
//                 amount: totals?.total
//               });
//               totalEnteredPayments = parseFloat(totals?.total);
//             }

//             const invoice = id
//               ? await update_invoice({
//                 ...data?.data,
//                 id: id,
//                 customer: customer,
//                 date: new Date(),
//                 due_date: "",
//                 details: details,
//                 subtotal: totals?.subtotal,
//                 taxamount: totals?.taxamount,
//                 discount: totals?.discount,
//                 delivery: totals?.delivery,
//                 delivery_status: 2,
//                 delivery_date: new Date(),
//                 payment_status: 2,
//                 payment_types: paymenttypedata,
//                 payments: paymentdata,
//                 total: totals?.total,
//                 source: "Billing"
//               })
//               : await create_invoice({
//                 customer: customer,
//                 date: new Date(),
//                 due_date: "",
//                 details: details,
//                 subtotal: totals?.subtotal,
//                 taxamount: totals?.taxamount,
//                 discount: totals?.discount,
//                 delivery: totals?.delivery,
//                 delivery_status: totals?.delivery_status,
//                 delivery_date: totals?.delivery_date,
//                 payment_status: totals?.payment_status,
//                 payment_types: paymenttypedata,
//                 payments: paymentdata,
//                 status: 1,
//                 total: totals?.total,
//                 source: "Billing"
//               });

//             if (invoice?.status) {
//               if (submitType.current === "print") {
//                 navigate(`/app/billing/view/${invoice?.data}`);
//                 toast?.success(invoice?.message);
//               } else {
//                 toast?.success(invoice?.message);
//               }

//               setDetails([]);
//               setCustomer();
//               setTotals({
//                 subtotal: "0.000",
//                 taxamount: "0.000",
//                 discount: 0,
//                 delivery: 0,
//                 delivery_status: 2,
//                 delivery_date: new Date(),
//                 payment_status: 2,
//                 payment_types: ["Cash"],
//                 /* payments: {
//                   Cash: "",
//                   Cheque: "",
//                   "Debit card": "",
//                   "Credit card": "",
//                   "Bank transfer": "",
//                   "Online payment": "",
//                 }, */
//                 payments: [{
//                   id: `temp-cash-initial`,
//                   name: "Cash",
//                   amount: ""
//                 }],
//                 paid: 0,
//                 remaining: 0,
//                 total: "0.000",
//               });
//               setButtonLoader(false);
//             } else {
//               toast?.error(invoice?.message);
//               setButtonLoader(false);
//             }
//           } else {
//             toast?.error("Select payment mode");
//           }
//         } else {
//           toast?.error(`Unit missing item ${details_count}`);
//         }
//       } else {
//         toast?.error("Add Items");
//       }
//     }
//   };

//   const handleData = (invoice) => {
//     let customer = invoice?.customer?._id ? invoice?.customer?._id : null;
//     let number = invoice?.number ? invoice?.number : "";
//     let date = invoice?.date ? invoice?.date : "";
//     let due_date = invoice?.due_date ? invoice?.due_date : "";
//     let status = invoice?.status ? invoice?.status : 0;

//     let customer_option = invoice?.customer?._id
//       ? [
//         {
//           value: invoice?.customer?._id,
//           label: invoice?.customer?.name,
//         },
//       ]
//       : null;

//     values[0].options[0].form.value = customer;
//     values[0].options[0].form.options = customer_option;
//     values[0].options[1].form.value = number;
//     values[0].options[2].form.value = date;
//     values[0].options[3].form.value = due_date;
//     values[0].options[4].form.value = status;

//     let data = [];
//     invoice?.details?.map((value, index) => {
//       data?.push({
//         id: value?._id,
//         description: value?.description?._id,
//         options: [
//           {
//             value: value?.description?._id,
//             label: value?.description?.product?.name,
//           },
//         ],
//         unit: value?.unit,
//         sale_price: value?.sale_price,
//         quantity: value?.quantity,
//         delivered: value?.delivered,
//         discount: value?.discount,
//         delivery: value?.delivery,
//         tax: value?.tax,
//         total: value?.total,
//       });
//     });

//     let payment_types = [];
//     let payments = [];

//     invoice?.payments?.forEach((payment) => {
//       if (!payment_types.includes(payment?.name)) {
//         payment_types.push(payment?.name);
//       }

//       payments.push({
//         id: payment?._id || `temp-${payment?.name}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
//         name: payment?.name,
//         amount: payment?.amount
//       });
//     });

//     totals.subtotal = invoice?.subtotal;
//     totals.taxamount = invoice?.taxamount;
//     totals.discount = invoice?.discount;
//     totals.delivery = invoice?.delivery;
//     totals.delivery_status = invoice?.delivery_status;
//     totals.delivery_date = invoice?.delivery_date;
//     totals.payment_status = invoice?.payment_status;
//     /*  totals.payment_types = JSON?.parse(invoice?.payment_types);
//      totals.payments = JSON?.parse(invoice?.payments); */
//     totals.payment_types = payment_types;
//     totals.payments = payments;
//     totals.paid = invoice?.paid;
//     totals.remaining = invoice?.remaining;
//     totals.total = invoice?.total;

//     setValues([...values]);
//     setDetails([...data]);
//     setTotals({ ...totals });
//     setLoader(false);
//   };

//   const fetchData = async () => {
//     if (id) {
//       setLoader(true);

//       const data = {
//         id: id,
//       };

//       const invoice = await get_invoice(data);
//       if (invoice?.status) {
//         handleData(invoice?.data);
//       } else {
//         toast?.error(invoice?.message);
//       }
//     } else {
//       const get_branch = await get_auth_branch();

//       if (get_branch?.status) {
//         if (get_branch?.data?.billing) {
//           navigate("/app/billing/new/add");
//         }
//       }

//       // setLoader(false);
//       values[0].options[2].form.value = new Date();
//       // values[0].options[3].form.value = new Date();

//       totals.delivery_status = 2;
//       totals.delivery_date = new Date();
//       totals.payment_status = 2;
//       totals.payment_types = ["Cash"];

//       setValues([...values]);
//       setTotals({ ...totals });
//       setLoader(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, []);

//   return (
//     <Header headers={header} setHeaders={setHeader} formdata={formdata}>
//       <Loadercomponent loader={loader}>
//         <div className="fixed top-56 right-8 transform -translate-y-1/2 z-50">
//           <div className="flex rounded-md border border-gray-300 bg-white ">
//             <button
//               className={
//                 location?.pathname == "/app/billing/add"
//                   ? "p-2 text-white bg-green-500 block"
//                   : "p-2 text-green-500 hover:bg-gray-50 block"
//               }
//               onClick={() => navigate("/app/billing/add")}
//             >
//               <BillingIcon />
//             </button>
//             <button
//               className={
//                 location?.pathname == "/app/billing/new/add"
//                   ? "p-2 text-white bg-green-500 block"
//                   : "p-2 text-green-500 hover:bg-gray-50 block"
//               }
//               onClick={() => navigate("/app/billing/new/add")}
//             >
//               <SalesIcon />
//             </button>
//           </div>
//         </div>
//         <BillingPos
//           loader={loader}
//           setLoader={setLoader}
//           options={options}
//           setOptions={setOptions}
//           customer={customer}
//           setCustomer={setCustomer}
//           details={details}
//           setDetails={setDetails}
//           totals={totals}
//           setTotals={setTotals}
//           formdata={formdata}
//           buttonLoader={buttonLoader}
//           ref={submitType}
//         />
//       </Loadercomponent>
//     </Header>
//   );
// };

// export default InvoicesForm;


// V2 - Updated with Prescription & Note (Modern Payment Structure)
import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import Header from "../../../../Componets/Header";
import {
  create_invoice,
  get_invoice,
  update_invoice,
} from "../../../../Controllers/Sales/Invoices";
import forms from "../../../../Data/Forms/Sales/Invoices/forms";
import headers from "../../../../Data/Forms/Billings/Billings/headers";
import Loadercomponent from "../../../../Componets/Loader";
import BillingPos from "../../../../Data/Forms/Billings/Billings/pos";
import BillingIcon from "../../../../Assets/Svg/billing";
import SalesIcon from "../../../../Assets/Svg/sales";
import { get_auth_branch } from "../../../../Controllers/Settings/Branches";

const InvoicesForm = () => {
  let { id } = useParams();
  let location = useLocation();
  let navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);
  const [values, setValues] = useState(forms);
  const [header, setHeader] = useState(headers);

  const submitType = useRef("");

  // ✅ Note & Prescription
  const [note, setNote] = useState("");
  const [prescription, setPrescription] = useState({
    R: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
    L: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
  });

  const [customer, setCustomer] = useState();
  const [options, setOptions] = useState();
  const [details, setDetails] = useState([]);

  const [totals, setTotals] = useState({
    subtotal: "0.000",
    taxamount: "0.000",
    discount: 0,
    delivery: 0,
    delivery_status: 2,
    delivery_date: new Date(),
    payment_status: 2,
    payment_types: ["Cash"],
    payments: [{ id: `temp-cash-initial`, name: "Cash", amount: "" }],
    paid: 0,
    remaining: 0,
    total: "0.000",
  });

  const formdata = async (data) => {
    if (buttonLoader) return;

    if (data?.status) {
      if (details?.length > 0) {
        let details_count = details.filter(v => v?.unit).length;

        if (details.length === details_count) {
          if (totals?.payment_types?.length > 0) {
            setButtonLoader(true);

            const paymentdata = totals?.payments?.filter(p => p.amount && parseFloat(p.amount) > 0) || [];

            let totalEnteredPayments = paymentdata.reduce((sum, p) => sum + parseFloat(p.amount || 0), 0);

            if (totalEnteredPayments === 0 && totals.payment_types.length > 0) {
              const firstMethod = totals.payment_types[0];
              paymentdata.push({ id: `temp-${firstMethod}`, name: firstMethod, amount: totals?.total });
              totalEnteredPayments = parseFloat(totals?.total);
            }

            const invoice = id
              ? await update_invoice({
                  ...data?.data,
                  id,
                  customer,
                  date: new Date(),
                  due_date: "",
                  details,
                  subtotal: totals?.subtotal,
                  taxamount: totals?.taxamount,
                  discount: totals?.discount,
                  delivery: totals?.delivery,
                  delivery_status: 2,
                  delivery_date: new Date(),
                  payment_status: 2,
                  payment_types: totals?.payment_types,
                  payments: paymentdata,
                  total: totals?.total,
                  source: "Billing",
                  note,
                  prescription: JSON.stringify(prescription),     // ✅ Stringified
                })
              : await create_invoice({
                  customer,
                  date: new Date(),
                  due_date: "",
                  details,
                  subtotal: totals?.subtotal,
                  taxamount: totals?.taxamount,
                  discount: totals?.discount,
                  delivery: totals?.delivery,
                  delivery_status: totals?.delivery_status,
                  delivery_date: totals?.delivery_date,
                  payment_status: totals?.payment_status,
                  payment_types: totals?.payment_types,
                  payments: paymentdata,
                  status: 1,
                  total: totals?.total,
                  source: "Billing",
                  note,
                  prescription: JSON.stringify(prescription),     // ✅ Stringified
                });

            if (invoice?.status) {
              toast.success(invoice?.message);

              if (submitType.current === "print") {
                navigate(`/app/billing/view/${invoice?.data}`);
              }

              // Reset
              setDetails([]);
              setCustomer();
              setNote("");
              setPrescription({
                R: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
                L: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
              });
              setTotals({
                ...totals,
                subtotal: "0.000",
                taxamount: "0.000",
                discount: 0,
                delivery: 0,
                total: "0.000",
                payments: [{ id: `temp-cash-initial`, name: "Cash", amount: "" }],
              });
            } else {
              toast.error(invoice?.message);
            }
            setButtonLoader(false);
          } else {
            toast.error("Select payment mode");
            setButtonLoader(false);
          }
        } else {
          toast.error(`Unit missing item ${details.length - details_count}`);
          setButtonLoader(false);
        }
      } else {
        toast.error("Add Items");
        setButtonLoader(false);
      }
    }
  };

  const handleData = (invoice) => {
    // ... (same as before)
    let customerId = invoice?.customer?._id || null;

    setNote(invoice?.note || "");
    setPrescription(invoice?.prescription || {
      R: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
      L: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
    });

    // Rest of handleData remains same...
    let customer_option = customerId ? [{ value: customerId, label: invoice?.customer?.name }] : null;

    values[0].options[0].form.value = customerId;
    values[0].options[1].form.value = invoice?.number || "";
    values[0].options[2].form.value = invoice?.date || "";
    values[0].options[3].form.value = invoice?.due_date || "";
    values[0].options[4].form.value = invoice?.status || 0;

    // Details mapping...
    let data = invoice?.details?.map(value => ({
      id: value?._id,
      description: value?.description?._id,
      options: [{ value: value?.description?._id, label: value?.description?.product?.name }],
      unit: value?.unit,
      unit_name: value?.unit_name || "",
      sale_price: value?.sale_price,
      quantity: value?.quantity,
      delivered: value?.delivered,
      discount: value?.discount,
      delivery: value?.delivery,
      tax: value?.tax,
      total: value?.total,
      frame_type: value?.frame_type || "",
      lens_type: value?.lens_type || "",
    })) || [];

    // Payments handling (your existing logic)
    let payment_types = [];
    let payments = [];
    invoice?.payments?.forEach(payment => {
      if (!payment_types.includes(payment?.name)) payment_types.push(payment?.name);
      payments.push({
        id: payment?._id || `temp-${payment?.name}`,
        name: payment?.name,
        amount: payment?.amount
      });
    });

    totals.subtotal = invoice?.subtotal;
    totals.taxamount = invoice?.taxamount;
    totals.discount = invoice?.discount;
    totals.delivery = invoice?.delivery;
    totals.delivery_status = invoice?.delivery_status;
    totals.delivery_date = invoice?.delivery_date;
    totals.payment_status = invoice?.payment_status;
    totals.payment_types = payment_types;
    totals.payments = payments;
    totals.paid = invoice?.paid;
    totals.remaining = invoice?.remaining;
    totals.total = invoice?.total;

    setValues([...values]);
    setDetails([...data]);
    setTotals({ ...totals });
    setLoader(false);
  };

  const fetchData = async () => {
    if (id) {
      setLoader(true);
      const invoice = await get_invoice({ id });
      if (invoice?.status) handleData(invoice?.data);
      else toast.error(invoice?.message);
    } else {
      const get_branch = await get_auth_branch();
      if (get_branch?.status && get_branch?.data?.billing) {
        navigate("/app/billing/new/add");
      }

      values[0].options[2].form.value = new Date();
      totals.delivery_status = 2;
      totals.delivery_date = new Date();
      totals.payment_status = 2;
      totals.payment_types = ["Cash"];

      setValues([...values]);
      setTotals({ ...totals });
      setNote("");
      setPrescription({
        R: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
        L: { sph: "-", cyl: "-", axis: "-", add: "-", prism: "-", pd: "-" },
      });
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader}>
        <div className="fixed top-56 right-8 transform -translate-y-1/2 z-50">
          <div className="flex rounded-md border border-gray-300 bg-white">
            <button className={location?.pathname === "/app/billing/add" ? "p-2 text-white bg-green-500" : "p-2 text-green-500 hover:bg-gray-50"} onClick={() => navigate("/app/billing/add")}>
              <BillingIcon />
            </button>
            <button className={location?.pathname === "/app/billing/new/add" ? "p-2 text-white bg-green-500" : "p-2 text-green-500 hover:bg-gray-50"} onClick={() => navigate("/app/billing/new/add")}>
              <SalesIcon />
            </button>
          </div>
        </div>

        <BillingPos
          loader={loader}
          setLoader={setLoader}
          options={options}
          setOptions={setOptions}
          customer={customer}
          setCustomer={setCustomer}
          details={details}
          setDetails={setDetails}
          totals={totals}
          setTotals={setTotals}
          formdata={formdata}
          buttonLoader={buttonLoader}
          note={note}
          setNote={setNote}
          prescription={prescription}
          setPrescription={setPrescription}
          ref={submitType}
        />
      </Loadercomponent>
    </Header>
  );
};

export default InvoicesForm;